import { fireOperationalAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { FormQuestionType, FormStatus } from '../../../form-system/models/Form';
import { validate } from '../../models/validators';
export var loadChoicesFn = function loadChoicesFn(getFormChoices, errorUtils) {
  var loadFormChoicesForASubmittedForm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var createAnalyticsEvent = arguments.length > 3 ? arguments[3] : undefined;
  return function (formStore) {
    return function (questionId, query) {
      if (!loadFormChoicesForASubmittedForm && formStore.status !== FormStatus.Open) {
        // When a form is submitted, the choices are stored within the questions.
        return Promise.resolve();
      }
      // map jiraField to QuestionStore[] for easy lookup of all questions which are linked to a Jira field.
      var jiraFieldQuestionMap = new Map();
      // map jiraField to QuestionStore[] for easy lookup of all questions which are linked to a data connection.
      var dataConnectionQuestionMap = new Map();
      // Allocate out each linked choice question to either the appropriate map.
      formStore.questions.forEach(function (question) {
        if (!questionId || questionId === question.id) {
          if (question.formQuestion.jiraField && isChoiceType(question.formQuestion.type)) {
            var questionStores;
            if (jiraFieldQuestionMap.has(question.formQuestion.jiraField)) {
              questionStores = jiraFieldQuestionMap.get(question.formQuestion.jiraField);
            } else {
              questionStores = [];
              jiraFieldQuestionMap.set(question.formQuestion.jiraField, questionStores);
            }
            questionStores.push(question);
          }
          if (question.formQuestion.dcId) {
            var _questionStores = dataConnectionQuestionMap.get(question.formQuestion.dcId);
            if (_questionStores === undefined) {
              _questionStores = [];
              dataConnectionQuestionMap.set(question.formQuestion.dcId, _questionStores);
            }
            _questionStores.push(question);
          }
        }
      });
      var lookups = [];

      // Retrieve formStore choices from the backend if there are any linked choice fields handled by ProForma
      if (jiraFieldQuestionMap.size > 0 || dataConnectionQuestionMap.size > 0) {
        lookups.push(getFormChoices(formStore.templateFormId, formStore.formId).then(function (response) {
          var validationResult = validate('ApiFormChoicesResponseSchema', response);
          if (!validationResult.isValid) {
            errorUtils.reportError(new Error('Response type mismatch'), {
              id: 'ApiFormChoicesResponseSchema',
              attributes: {
                errors: JSON.stringify(validationResult.errors)
              }
            });
            return;
          }
          var fields = response.fields,
            dataConnections = response.dataConnections;
          jiraFieldQuestionMap.forEach(function (questionStores, jiraField) {
            if (fields[jiraField]) {
              questionStores.forEach(function (questionStore) {
                return questionStore.setChoices(fields[jiraField]);
              });
            }
          });
          dataConnectionQuestionMap.forEach(function (questionStores, dcId) {
            if (dataConnections[dcId]) {
              questionStores.forEach(function (questionStore) {
                questionStore.setChoices(dataConnections[dcId]);
              });
            } else {
              if (createAnalyticsEvent) {
                fireOperationalAnalytics(createAnalyticsEvent({}), "".concat(ActionSubject.FORM_FIELD_CHOICES_DATA_CONNECTION, " ").concat(Action.FAILED), {
                  formId: formStore.formId,
                  templateFormId: formStore.templateFormId,
                  dcId: dcId
                });
              }
            }
          });
        }));
      }
      return Promise.all(lookups).then(function (_) {});
    };
  };
};
function isChoiceType(questionType) {
  return questionType === FormQuestionType.ChoiceCascading || questionType === FormQuestionType.ChoiceDropdown || questionType === FormQuestionType.ChoiceSingle || questionType === FormQuestionType.ChoiceMultiple || questionType === FormQuestionType.ChoiceDropdownMultiple;
}